//skills import 
import bootsrap from '../assets/skills/bootstrap.png'
import graphql from '../assets/skills/graphql.png'
import css from '../assets/skills/css.png'
import dotnet from '../assets/skills/dotnet.svg'
import express from '../assets/skills/express.png'
import js from '../assets/skills/js.png'
import mongodb from '../assets/skills/mongodb.svg'
import mui from '../assets/skills/mui.svg'
import next from '../assets/skills/next.png'
import parcel from '../assets/skills/parcel.png'
import postgres from '../assets/skills/postgres.png'
import react from '../assets/skills/react.png'
import reactq from '../assets/skills/react-query.svg'
import sass from '../assets/skills/sass.png'
import tailwind from '../assets/skills/tailwind.svg'
import ts from '../assets/skills/ts.png'
import vite from '../assets/skills/vite.png'

//Project imports
import nike from '../assets/projects/nike.png'
import gym from '../assets/projects/gym.png'
import tesla from '../assets/projects/tesla.png'
import car from '../assets/projects/car.png'
import gpt from '../assets/projects/gpt.png'
import aboutmeImg from '../assets/me/headerImg.png'


//Skills List
export const skills = [
    {
        skill:postgres,
        percent: "70%",
        name:"PostgreSQL",
        webURL:"https://postgresql.org"
    },
    {
        skill:bootsrap,
        percent: "80%",
        name:"Bootsrap",
        webURL:"https://getbootstrap.com"
    },
    {
        skill:css,
        percent: "91%",
        name:"CSS",
        webURL:"https://www.w3.org/Styyle/CSS/Overview.en.html"
    },
    {
        skill:dotnet,
        percent: "34%",
        name:"DotNet",
        webURL:"https://dotnet.microsoft.com/"
    },
    {
        skill:express,
        percent: "63%",
        name:"Express",
        webURL:"https://expressjs.com"
    },
    {
        skill:graphql,
        percent: "66%",
        name:"GraphQL",
        webURL:"https://graphql.org"
    },
    {
        skill:js,
        percent: "70%",
        name:"Javascript",
        webURL:"https://javascript.com"
    },
    {
        skill:mongodb,
        percent: "28%",
        name:"Mongodb",
        webURL:"https://mongodb.com"
    },
    {
        skill:mui,
        percent: "73%",
        name:"mui",
        webURL:"https://mui.com"
        
    },
    {
        skill:next,
        percent: "79%",
        name:"Next",
        webURL:"https://nextjs.org"
    },
    {
        skill:parcel,
        percent: "43%",
        name:"Mongodb",
        webURL:"https://mongodb.com"
    },
    {
        skill:react,
        percent: "89%",
        name:"Mongodb",
        webURL:"https://mongodb.com"
    },
    {
        skill:reactq,
        percent: "82%",
        name:"Mongodb",
        webURL:"https://mongodb.com"
    },
    {
        skill:sass,
        percent: "36%",
        name:"Mongodb",
        webURL:"https://mongodb.com"
    },
    {
        skill:tailwind,
        percent: "80%",
        name:"Mongodb",
        webURL:"https://mongodb.com"
    },
    {
        skill:ts,
        percent: "55%",
        name:"Mongodb",
        webURL:"https://mongodb.com"
    },
    {
        skill:vite,
        percent: "70%",
        name:"Mongodb",
        webURL:"https://mongodb.com"
    },

]

export default skills;

//Experience List

export const experience = [
    {
        role:"Junior Software Developer",
        companyName:"Lior Information Technology",
        period:"Jan 2021 - Aug 2022",
        summary:"Developed Websites using Wordpress, React.Troubleshooted client websites and managed client email accounts",
    }
]

export const project = [
    {
        name: "Car Rental App",
        imgURL: car,
        details: "Frontend Car rental application project that allows users to select and book their intended vehicles",
        webURL: "https://nqaba-car.netlify.app",

    },
    {
        name: "Exercise App",
        imgURL: gym,
        details: "This is a gym app that uses an api from rapid-api to fetch data",
        webURL: "https://nqaba-gym.netlify.app",
    },
    
    {
        name: "GPT-3",
        imgURL: gpt,
        details:"This app was created from the use of a figma design to relic the actual gpt-3 landing page ",
        webURL: "https://nqaba-gpt3.netlify.app",
    },
    {
        name: "Nike Landing Page",
        imgURL: nike,
        details: "Exercising my frontend development skills i developed a nike landing page",
        webURL: "https://nqaba-nike.netlify.app",
    },
    {
        name: "tesla landing page",
        imgURL: tesla,
        details:"Tesla landing page to showcase my front-end development skills",
        webURL: "https://nqaba-tesla.netlify.app",
      
    }
]

export const aboutme = [
    {
        imgURL:aboutmeImg,
        text:"My name Nqaba Jabulani Sikeyi. I use most of my spare time in learning and finding ways to elevate myself. Mostly am into programing stuff, but if am not programing or watching anime you can find me playing chess. So if we were to work together be sure am going to challenge you in a game of chess.",
    }
]